import styled from "styled-components";
import { colors, text, values } from "~/assets/js/theme/constants";

export const typeToColor = (type) => {
    switch (type) {
        case "info":
            return colors.LAYOUT.GRAY;
        case "alert":
            return colors.SEMANTIC.WARNING;
        // case "ok":
        //     return colors.SEMANTIC.SUCCESS;
        case "error":
            return colors.SEMANTIC.DANGER;
    }
};

export const NotificationContainer = styled.div`
    font-family: ${text.REGULAR.FONT} !important;
    font-weight: ${text.REGULAR.WEIGHT} !important;
    margin: 8px;
    border-radius: ${values.BORDER_RADIUS}px;
    padding: ${(props) => (props.big ? 12 : 8)}px;
    padding-right: 12px;
    background-color: ${(props) => typeToColor(props.type)[100]};
    font-size: 18px;
    line-height: 22.5px;
    display: flex;
    text-align: center;
    flex-direction: ${(props) => (props.big ? "column" : "row")};
    align-items: center;
    .icon-container {
        background-color: ${(props) =>
            props.big ? "#00000000" : typeToColor(props.type)[200]};
        display: flex;
        align-items: center;
        justify-content: center;
        ${(props) =>
            props.big
                ? `
    margin-bottom: 10px;
    margin-top: 4px;`
                : `
    height: 32px;
    width: 32px;`}
        border-radius: 32px;
        margin-right: 8px;
    }
`;
